export interface SuggestionSelection {value:string;label:string;productId?:number;acceptedMessageId?:string}
/** Match an explicit choice against the original saved response, never the latest picker. */
export function resolveSuggestionChoice(source:any,value:unknown,acceptedMessageId?:string):SuggestionSelection {
 const pill=source?.suggestionPills?.pills?.find((item:any)=>item.value===value);
 if(source?.role!=='assistant'||typeof value!=='string'||!pill)throw new Error('This choice is unavailable. Reopen the original task and try again.');
 if(source.suggestionSelection&&source.suggestionSelection.value!==value)throw new Error('This question has already been answered.');
 return source.suggestionSelection??{value: pill.value,label:pill.label,productId:pill.productId,acceptedMessageId};
}
/** Legacy saved chats did not stamp consumed choices. Require an exact answer plus a saved result. */
export function savedSuggestionSelection(source:any,messages:any[]):SuggestionSelection|undefined {
 if(source.suggestionSelection)return source.suggestionSelection;
 const index=messages.findIndex(message=>message.id===source.id);
 if(index<0)return;
 const later=messages.slice(index+1);
 const answerIndex=later.findIndex(message=>message.role==='user');
 if(answerIndex<0)return;
 const answer=later[answerIndex];
 const pill=source.suggestionPills?.pills?.find((item:any)=>item.value===answer.content);
 if(!pill)return;
 const response=later.slice(answerIndex+1).find(message=>message.role==='assistant');
 if(!response||!(response.angleSetCard||response.conceptsRun?.setId||response.playbookProgress?.isDone||response.playbookJobs?.some((job:any)=>job.status==='completed')))return;
 return {value:pill.value,label:pill.label,productId:pill.productId,acceptedMessageId:response.id};
}

/** Preserve server-owned settings and choice claims across stale client transcript saves. */
export function preserveTaskUIState(prior:any[],incoming:any[]):any[]{
 const byId=new Map(prior.filter(entry=>typeof entry?.id==='string').map(entry=>[entry.id,entry]));
 const merged=incoming.filter(entry=>entry?.role!=='metadata').map(entry=>{
  const saved=byId.get(entry.id);
  const {suggestionSelection:_untrustedSelection,uiAction:_untrustedUIAction,...next}=entry;
  if(saved && Object.hasOwn(saved,'suggestionSelection'))next.suggestionSelection=saved.suggestionSelection;
  if(saved?.uiAction === 'build_campaign' && saved.role === 'user')next.uiAction=saved.uiAction;
  if(saved?.creativeMode)next.creativeMode=saved.creativeMode;
  return next;
 });
 for(const saved of prior){
  if(saved?.id==='task-creative-mode'||((Object.hasOwn(saved??{},'suggestionSelection')||saved?.uiAction === 'build_campaign')&&!merged.some(entry=>entry.id===saved.id)))merged.push(saved);
 }
 return merged;
}
